import {AfterContentInit, Component, ContentChild, OnDestroy} from "@angular/core";
import {
    AbstractSearchControlComponent,
    SearchControlFieldSelector
} from "../../../../framework/entity/search/search-controls/abstract-search-control.component";
import {FilterModel} from "../../../../framework/bi/filter/filter.model";
import {debounceTime, distinctUntilChanged, Subject, Subscription} from "rxjs";
import {DimensionControlsService} from "../dimension-controls.service";
import {SearchControlSelectObjects} from "../../../../framework/entity/select/search-control-select-objects";
import {FilterValueChangedEvent} from "@fedeltapointofsale/data-client";

@Component({
    selector: "wbo-bi-dimension-search-control",
    template: "<ng-content></ng-content>"
})
export class DimensionSearchControlComponent implements AfterContentInit, OnDestroy {

    field: string;

    @ContentChild(SearchControlFieldSelector) control: AbstractSearchControlComponent;

    private internalValueChanges: Subject<any> = new Subject<any>();

    private subscriptions: Subscription = new Subscription();

    constructor(public filterModel: FilterModel, private dimensionControlsService: DimensionControlsService) {
        this.field = dimensionControlsService.currentField;

        // When the filter changes set the control value
        this.subscriptions.add(this.filterModel.filterFieldChange.subscribe((event: FilterValueChangedEvent) => {
            if (event.filterName === this.field) {
                this.setValueToControl(event.value);
            }
        }));
    }

    ngAfterContentInit(): void {
        this.control.label = "wbo.bi.search.field." + this.field + ".label";
        this.control.placeholder = "wbo.bi.search.field." + this.field + ".placeholder";
        this.control.elementId = "search-filter-control-" + this.field;

        this.control.registerOnChange((value) => this.internalValueChanges.next(Array.isArray(value) ? value.slice() : value));
        this.setValueToControl(this.filterModel.filter[this.field]);

        // when the control value changes set the filter value
        this.subscriptions.add(this.internalValueChanges.pipe(
            debounceTime(400),
            distinctUntilChanged()
        ).subscribe(term => {
            this.filterModel.setFilterValue(this.field, term);
        }));

        this.subscriptions.add(this.control.removeControl.subscribe(() =>
            this.dimensionControlsService.requestRemoveFormField(this.field)));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    private setValueToControl(value: any): void {
        if (value instanceof SearchControlSelectObjects) {
            this.control.setSearchControlSelectObjects(value);
        } else {
            this.control.writeValue(value);
        }
    }
}
